import script from "./Dictionary.vue?vue&type=script&setup=true&lang=js"
export * from "./Dictionary.vue?vue&type=script&setup=true&lang=js"

import "./Dictionary.vue?vue&type=style&index=0&id=05fe3cb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fe3cb9"]])

export default __exports__